//import {YMap, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer, YMapMarker, reactify} from 'yandex/ymaps3-reactify';
//import { YMap , YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer, YMapMarker, reactify} from "@yandex/ymaps3-types";

const LOCATION = {
  center: [37.588144, 55.733842],
  zoom: 9
};
function FTYandexMap(props) {
   const apiKey=props.apiKey;
  return (
   
     <div style={{width: '600px', height: '400px'}}>
  
    </div>
  );
}

export default FTYandexMap;